import { PrivacyPolicy, getPrivacyPolicyEndpoint } from 'cpes-common';
import { createCmsContentSlice } from 'cms-integration';

const { reducer, fetchContent } = createCmsContentSlice<PrivacyPolicy>({
    contentName: 'privacyPolicy',
    contentEndpoint: getPrivacyPolicyEndpoint,
});

export default reducer;
export const fetchPrivacyPolicy = fetchContent;
